<main data-testid="main">
    <div class="content-container" data-testid="content-container">
        <slot />
    </div>
</main>

<style lang="scss">
    @use '@amp/web-shared-styles/sasskit-stylekit/ac-sasskit-config';
    @use 'ac-sasskit/modules/viewportcontent/core' as *;
    @use '@amp/web-shared-styles/app/core/viewports' as *;

    main {
        flex-grow: 1;
    }

    .content-container {
        width: 100%;
        min-height: 100%;
        margin: 0 auto;
        max-width: viewport-content-for(xlarge);
        position: relative;
        z-index: var(--z-default);

        :global(.search-input-wrapper) {
            @media (--sidebar-visible) {
                display: none;
            }
        }
    }
</style>
